import React from 'react';
import { ReferralSurvey } from '../features/ReferralSurvey';
import { useTranslation } from 'react-i18next';

const ReferralSurveyScreenView = () => {
    const { t } = useTranslation()
    return (
        <div
            className="min-vh-100 d-flex align-items-center justify-content-center p-4 position-relative"
            style={{ backgroundColor: 'var(--bg-primary)', color: 'var(--text-primary)' }}
        >
            <div className="w-100" style={{ maxWidth: '32rem' }}>
                <div
                    className="rounded shadow overflow-hidden p-4"
                    style={{
                        backgroundColor: 'var(--bg-surface)',
                        color: 'var(--text-primary)',
                        border: '1px solid var(--border-subtle)',
                    }}
                >
                    <ReferralSurvey t={t} />
                </div>
            </div>
        </div>
    );
};

export default ReferralSurveyScreenView;
